import { render, staticRenderFns } from "./report-she.vue?vue&type=template&id=51485b9a&scoped=true&"
import script from "./report-she.vue?vue&type=script&lang=ts&"
export * from "./report-she.vue?vue&type=script&lang=ts&"
import style0 from "./report-she.vue?vue&type=style&index=0&id=51485b9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51485b9a",
  null
  
)

export default component.exports